import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Programs',
    href: '#programs'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Fees & CCS',
    href: '#fees'
  }, {
    name: '3 Day Guarantee',
    href: '#3-day-guarantee'
  }, {
    name: 'Tours',
    href: '#tours'
  }, {
    name: 'FAQs',
    href: '#faqs'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-383">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-384">
        <a href="#" className="flex-shrink-0 relative z-50" data-id="element-385">
          <img src="https://cdn.magicpatterns.com/uploads/2zHGBywaBCAxo8bMoxkHDW/Funtastic-kidz-logo.svg" alt="Funtastic Kidz Early Learning Centre" className="h-12 w-auto" data-id="element-386" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-387">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-navy hover:text-blue font-semibold transition-colors text-sm" data-id="element-388">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-389">
          <a href="tel:0387143350" className="flex items-center gap-2 text-navy hover:text-blue font-bold transition-colors" data-id="element-390">
            <Phone size={18} className="text-blue" data-id="element-391" />
            <span data-id="element-392">03 8714 3350</span>
          </a>
          <a href="#tours" className="bg-coral text-white px-6 py-3 rounded-btn font-bold hover:bg-red transition-colors shadow-sm hover:shadow-md hover:-translate-y-0.5 transform duration-200" data-id="element-393">
            Book a Tour
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-navy p-2 relative z-50" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-394">
          {mobileMenuOpen ? <X size={28} data-id="element-395" /> : <Menu size={28} data-id="element-396" />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      <AnimatePresence data-id="element-397">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-sand py-4 px-6 flex flex-col gap-4 z-40" data-id="element-398">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-navy font-bold py-3 border-b border-sand/50 text-lg" onClick={() => setMobileMenuOpen(false)} data-id="element-399">
                {link.name}
              </a>)}
            <a href="tel:0387143350" className="flex items-center gap-3 text-navy font-bold py-3 text-lg" data-id="element-400">
              <div className="w-10 h-10 rounded-full bg-blue/10 flex items-center justify-center text-blue" data-id="element-401">
                <Phone size={20} data-id="element-402" />
              </div>
              <span data-id="element-403">03 8714 3350</span>
            </a>
            <a href="#tours" className="bg-coral text-white text-center px-6 py-4 rounded-btn font-bold mt-4 text-lg shadow-sm" onClick={() => setMobileMenuOpen(false)} data-id="element-404">
              Book a Tour
            </a>
          </motion.div>}
      </AnimatePresence>
    </header>;
}